import {
	CLOSE_MODAL,
	DESTROY_CUSTOMER_ID_AND_RESULT_CODE,
	OPEN_MODAL,
	SET_CUSTOMER_ID,
	SET_MODAL_MESSAGE,
	SET_MODAL_TITLE,
	SET_RESULT_CODE,
	SET_PREVIOUS_APPLICATION_VALUES,
} from './constants';

export const closeModal = () => ({
	type: CLOSE_MODAL,
});

export const openModal = () => ({
	type: OPEN_MODAL,
});

export const setCustomerId = customerId => ({
	type: SET_CUSTOMER_ID,
	customerId,
});

export const setModalMessage = message => ({
	type: SET_MODAL_MESSAGE,
	message,
});

export const setModalTitle = title => ({
	type: SET_MODAL_TITLE,
	title,
});

export const setResultCode = resultCode => ({
	type: SET_RESULT_CODE,
	resultCode,
});

export const destroyCustomerIdAndResultCode = () => ({
	type: DESTROY_CUSTOMER_ID_AND_RESULT_CODE,
});

export const setPreviousApplicationValues = previousApplicationValues => ({
	type: SET_PREVIOUS_APPLICATION_VALUES,
	previousApplicationValues,
});
